<div class="confirmPurchaseWrap section">
    <div class="gameHeader subHeader">
        <button class="back leftbtn" (click)="closeTicket()">
            <svg class="svgicon">
                <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
            </svg>
        </button>
        <div class="pageIndicator">
            <div class="title">{{'dge.purchase_det' | translate}}</div>
            <div class="userinfo">
                <div class="userName">{{userInfo?.playername}}</div>
                <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
            </div>
        </div>
    </div>
    <div class="purcahseDetailWrap">
        <div class="sectionWrapper">
            <div class="purcahseDetail-box">
                <div class="title">{{'common.'+ gameData?.gameCode | translate}}
                    <div class="subtitle" *ngIf="gameData?.drawRespVOs?.length == 1">
                        <span class="date">{{gameData?.drawRespVOs[0]?.drawDateTime | date:'dd/MM/y HH:mm:ss'}}</span>
                    </div>
                </div>
                <div class="playedRowWrap">
                    <div class="item-row" *ngFor="let panel of userData?.panelData; let pIndex = index;">
                        <div class="col1">
                            <div class="selection" *ngIf="betData[panel.betType].winMode == 'MAIN'">
                                <!-- <div class="valuebox" *ngFor="let pickedNo of panel.pickedValues; let k = index;">
                                    {{pickedNo}}
                                </div> -->
                                <div *ngFor="let pickedNo of panel.pickedValues; let k = index;"
                                    [ngClass]="{'withvaluepays': gameCode == 'ThaiLottery' && payoutWiseNumbersData[panel?.betType] && payoutWiseNumbersData[panel?.betType]?.numbers?.indexOf(pickedNo) > -1}">
                                    <div class="valuebox">{{pickedNo}}</div>
                                    <div class="paysbox"
                                        *ngIf="gameCode == 'ThaiLottery' && payoutWiseNumbersData[panel?.betType] && payoutWiseNumbersData[panel?.betType]?.numbers?.indexOf(pickedNo) > -1">
                                        x{{payoutWiseNumbersData[panel?.betType]?.colorData[payoutWiseNumbersData[panel?.betType]?.numbers?.indexOf(pickedNo)]?.slab}}
                                        {{'dge.pays' | translate | lowercase}}
                                    </div>
                                </div>
                            </div>
                            <div class="detail small"
                                *ngIf="gameCode == 'ThaiLottery' || gameCode == 'ThaiLotteryHighFrequency'">
                                <span>
                                    {{((betData[panel.betType]?.betGroup == "3Digit") ? 'dge.3_digit' :
                                    ((betData[panel.betType]?.betGroup == "2Digit") ? 'dge.2_digit' : 'dge.1_digit')) |
                                    translate}}
                                </span>
                                <span class="separator">:</span>
                                <span
                                    innerHTML="{{'dge.GD-'+getBetName(betData[panel.betType].betDispName)+'-'+betData[panel.betType].pickTypeData.pickType[panel.pickType].name | translate}}"></span>
                                <!-- <span>
                                    {{'dge.'+getBetName(betData[panel.betType].betDispName) | translate}}
                                </span>                                 -->
                                <!-- <span class="separator">-</span> -->
                                <!-- <span innerHTML="{{'dge.' + betData[panel.betType].pickTypeData.pickType[panel.pickType].name | translate}}"></span> -->
                                <!-- <ng-container *ngFor="let catElemt of betData[panel.betType].pickTypeData.pickType[panel.pickType].name.split('+'); let u = index;">
                                    {{u > 0 ? ' + ' : ''}}{{ catElemt | slice:-1}}<sup>{{ catElemt | slice:-1 | ordinal}}</sup>
                                </ng-container> {{'dge.cat' | translate}} -->
                            </div>
                            <div class="detail small" *ngIf="gameCode == 'TwoDMYANMAAR'">
                                <span>
                                    {{'dge.'+getBetName(betData[panel.betType].betDispName) | translate}}
                                </span>
                                <span class="separator">-</span>
                                <span>
                                    {{'dge.'+get2DPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].code,
                                    betData[panel.betType].pickTypeData.pickType[panel.pickType].name,
                                    panel?.pickedValues) | translate}}
                                </span>
                            </div>
                        </div>
                        <div class="col2">
                            <div class="amountWrap" innerHTML="{{calculatePanelPrice(pIndex) | custCurrency}}"></div>
                        </div>
                        <div class="col3" (click)="removePanel(pIndex)">
                            <svg class="svgicon trashIcon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-trash"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="salenotice" *ngIf="gameData?.betLimitEnabled == 'YES'">
                <span class="text">{{'dge.thai_sale_notice' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="confirmFooter fix-bottom bg-white">
        <div class="sectionWrapper">
            <div class="drawNumSelection" *ngIf="gameData?.drawRespVOs?.length > 1">
                <div class="label">{{'dge.no_draw' | translate}}</div>
                <div class="valueSelector">
                    <div class="btnWrap btn" (click)="drawChange('-')"><span>-</span></div>
                    <div class="inputWrap">
                        <input type="text" readonly maxlength="2" [(ngModel)]="numOfDrawsSelected"
                            (keyup)="onDrawInputChange()">
                    </div>
                    <div class="btnWrap btn" (click)="drawChange('+')"><span>+</span></div>
                </div>
                <div class="separator"><span class="txt">{{'dge.or' | translate}}</span></div>
                <div class="customSelectorBtn" (click)="openAdvDrawPopup()">
                    <button>
                        <div class="iconWrap">
                            <span class="badge" *ngIf="advanceDrawCount != '0'">{{advanceDrawCount}}</span>
                            <svg class="svgicon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-advanceddraw"></use>
                            </svg>
                        </div>
                        <div class="btnText">{{'dge.draw_list' | translate}}</div>
                    </button>
                </div>
            </div>
            <div class="powerzone">
                <div class="betInfoWrap">
                    <div class="betInfo">
                        <div class="txt">{{userData?.panelData?.length}}</div>
                        <div class="label">{{'dge.totbet' | translate}}</div>
                    </div>
                    <div class="betInfo">
                        <div class="txt" innerHTML="{{calculateTotalPrice() | custCurrency}}"></div>
                        <div class="label">{{'dge.totbetval' | translate}}</div>
                    </div>
                </div>
                <button class="buyNowBtn btn-primary" (click)="confirmTicketPurchase()">
                    {{'dge.cnfrm_buy' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>